function findVariantId(map, selections) {
  // selections: { index: value }
  const keys = Object.keys(selections);
  if (keys.length === 0) return map.defaultVariantId;

  const match = map.variants.find(v => {
    // v.o is array of option values in order
    return keys.every(k => v.o[Number(k)] === selections[k]);
  });

  return match && match.available ? match.id : null;
}

document.addEventListener("click", async (e) => {
  // prevent product card link open when clicking inside quick panel
  const quick = e.target.closest(".lr-quick");
  if (quick) {
    e.preventDefault();
    e.stopPropagation();
  }

  const btn = e.target.closest(".lr-quick__btn");
  if (!btn) return;

  const panel = btn.closest(".lr-quick");
  const optIndex = btn.dataset.opt;
  const val = btn.dataset.val;

  // store selection on panel dataset
  const selections = JSON.parse(panel.dataset.selections || "{}");
  selections[optIndex] = val;
  panel.dataset.selections = JSON.stringify(selections);

  // toggle active state for that option group
  panel.querySelectorAll(`.lr-quick__btn[data-opt="${optIndex}"]`).forEach(b => b.classList.remove("is-active"));
  btn.classList.add("is-active");
});





async function refreshCartDrawer() {
  // These are common section ids in many themes.
  // You may need to change them depending on your theme.
  const sections = ["cart-drawer", "cart-icon-bubble"];

  const res = await fetch(`/?sections=${sections.join(",")}`, { method: "GET" });
  const html = await res.json();

  // Replace cart drawer HTML
  if (html["cart-drawer"]) {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html["cart-drawer"];

    const newDrawer = wrapper.querySelector("cart-drawer") || wrapper.querySelector("#CartDrawer") || wrapper.firstElementChild;
    const oldDrawer = document.querySelector("cart-drawer") || document.querySelector("#CartDrawer");

    if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);
  }

  // Replace cart bubble HTML
  if (html["cart-icon-bubble"]) {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html["cart-icon-bubble"];

    const newBubble =
      wrapper.querySelector("#cart-icon-bubble") ||
      wrapper.querySelector("cart-icon-bubble") ||
      wrapper.firstElementChild;

    const oldBubble =
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector("cart-icon-bubble");

    if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
  }
}







document.addEventListener("click", async (e) => {
  const addBtn = e.target.closest(".lr-quick__add");
  if (!addBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const panel = addBtn.closest(".lr-quick");
  const mapEl = panel.querySelector(".lr-quick__map");
  if (!mapEl) return;

  const map = JSON.parse(mapEl.textContent);
  const selections = JSON.parse(panel.dataset.selections || "{}");

  // require both size selections (2 rows)
  const rows = panel.querySelectorAll(".lr-quick__row");
  if (rows.length >= 2) {
    const needed = Array.from(rows).map(r => r.dataset.optIndex);
    const hasAll = needed.every(i => selections[i] != null);
    if (!hasAll) {
      alert("Please select both sizes.");
      return;
    }
  }

  const variantId = findVariantId(map, selections);
  if (!variantId) {
    alert("This combination is unavailable.");
    return;
  }

  addBtn.disabled = true;

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    if (!res.ok) throw new Error("Add failed");

    // Tell theme/cart-drawer to update
document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

// If theme has a cart drawer trigger
const drawer = document.querySelector("cart-drawer");
if (drawer && typeof drawer.renderContents === "function") {
  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();
  drawer.renderContents(cart);
}
  } catch (err) {
    console.error(err);
    alert("Could not add to cart. Please try again.");
  } finally {
    addBtn.disabled = false;
  }
});